<template>
  <div>
    <list-page-header />
    <yv-index
      v-if="childComponentLoader"
      :path="path"
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :disabledHeaderActions="true"
      :sortable="sortable"
      :formatTableData="formatTableData"
      :tableActionsComponent="TableActions"
      ref="subjectsTable"
    >
    </yv-index>
  </div>
</template>

<script>
import { YvIndex } from "@/components/Base";
import { service_paths, service_names } from "@/constants/Services";
import Header from "./Header";
import TableActions from "./TableActions.vue";
import Swal from "sweetalert2";
import cloneDeep from "lodash/cloneDeep";
import { hasHistory, genErrMsgOj, Message } from "@/helpers/utils";
export default {
  name: "ListPage",
  components: { YvIndex, ListPageHeader: Header },
  data() {
    const self = this;
    return {
      childComponentLoader: false,
      gradeList: [],
      TableActions,
      path: service_paths.subjects,
      sortable: ["name", "status"],
      formSearch: [
        {
          label: "subject.name",
          name: "name__~",
          value: "",
          type: "input"
        },
        {
          label: "subject.code",
          name: "code__~",
          value: "",
          type: "input"
        },
        {
          label: "common.grade",
          name: "grade_id",
          value: "",
          type: "select",
          options: [],
          is_switch_locale: "false",
          trackBy: "id"
        },
        {
          label: "common.status",
          name: "status",
          value: "",
          type: "select",
          options: [
            {
              id: "",
              name: "common.all"
            },
            {
              id: "Active",
              name: "common.active"
            },
            {
              id: "Inactive",
              name: "common.inactive"
            }
          ]
        }
      ],
      columns: {
        name: "subject.name",
        code: "subject.code",
        type: "subject.type",
        status: "common.status",
        grade: "common.grade"
      }
    };
  },
  computed: {},
  created() {
    this.getGradesList();
  },
  methods: {
    formatTableData(table) {
      table.forEach(item => {
        item.grade = this.gradeList?.find(
          gradeItem => gradeItem.id === item.grade_id
        )?.name;
        item.type = item.subject_type?.name;
      });
      return table;
    },
    getGradesList() {
      this.$axios
        .get(service_paths.grades, { limit: 9999 })
        .then(response => {
          this.gradeList = response.data.data;
          this.childComponentLoader = true;
          this.formSearch[2].options = [
            { id: "", name: this.$t("common.all") },
            ...response.data.data
          ];
        })
        .catch(error => {
          console.log(error);
        });
    },
    reFetchTableData() {
      return this.$refs.subjectsTable.getTableData();
    },
    //delete
    async delete(data) {
      const id = data.id || data._id;
      await this.$axios
        .delete(this.path + "/" + id)
        .then(async () => {
          await this.reFetchTableData();
          Message.success(this.$t("common.delete_success"));
        })
        .catch(error => {
          console.log(error);
        });
    },
    confirmDelete(data) {
      Swal.fire({
        title: this.$t("common.confirmation"),
        text: this.$t("subject.text_confirm_delete"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-danger btn-fill",
        cancelButtonClass: "md-button md-secondary btn-fill",
        confirmButtonText: this.$t("common.delete"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.delete(data);
        }
      });
    }
  },
  provide() {
    return {
      confirmDelete: this.confirmDelete
    };
  }
};
</script>

<style lang="scss" scoped></style>
